import {Box, BoxProps, Stack, useTheme} from "@mui/joy";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {mergeSx} from "../components/joyx.tsx";
import {z} from "zod/v4";
import {FontAwesomeIconProps} from "../fa.tsx";
import {ReactNode} from "react";

export const CapsulableEntity = z.object({
    displayName: z.custom<ReactNode>(),
    id: z.optional(z.string()),
    code: z.optional(z.string()),
    icon: z.optional(FontAwesomeIconProps),
    showCode: z.optional(z.boolean()),
});

export type CapsulableEntity = z.infer<typeof CapsulableEntity>;

export interface EntityCapsuleProps extends Omit<BoxProps, "children"> {
    entity: CapsulableEntity | undefined;
}
//
// const EntityCapsuleRoot
//     = styled(Box, {
//     name: "EntityCapsule",
//     slot: "root"
// })<{ ownerState: EntityCapsuleProps }>(({theme}) => {
//     return {
//         fontSize: theme.fontSize.md,
// //        ...ownerState,
//         alignItems: "center",
//         display: "flex",
//         flexDirection: "row",
//         width: "auto",
//     };
// });

export function EntityCapsule({entity, sx: inSx, ...rest}: EntityCapsuleProps) {
    const {t} = useTranslation();
    const theme = useTheme();
    const displayName = entity?.displayName ?? t("unknown");
    const code = entity?.code;
    const icon = entity?.icon;
    const showCode = !!entity?.showCode;
    const sx= mergeSx({
        fontSize: theme.fontSize.md,
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        width: "auto",
    }, inSx);
    return <Box {...rest} sx={sx}>
        <Stack direction="row" sx={{alignItems: "center"}} spacing={0.4}>
            {icon
                ? <FontAwesomeIcon {...icon}/>
                : null}
            <Box sx={{
                overflow: "hidden",
                textOverflow: "ellipsis", whiteSpace: "nowrap",
            }}>
                {showCode && code && code !== displayName ? code : null}
                {showCode && code && code !== displayName && displayName ? "・" : null}
                {displayName ? displayName : t("unknown")}
            </Box>
        </Stack>
    </Box>
}

